import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  BASE_URL,
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getKeyPathValue,
  getMonthYear,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import {
  PHARMACY_INVOICE_FROM,
  PHARMACY_PRODUCT_TYPE,
  PHARMACY_PRODUCT_TYPE_MENUS,
  PHARMACY_SUPPLIER,
  PHARMACY_TYPE_MENUS_CONSIGNMENT
} from '../../../../../constants/dropdown';
import { PHARMACY_TYPE_MENUS } from '../../../../../constants/dropdown';
import { AddTCDForm } from './AddTCDform';
import { AddDetails } from './AddDetails';
import { dateFormatter } from '../../../../../utils';
import axios from 'axios';
import { AgainstPoAddDetailsForm } from './AgainstPoAddDetailsForm';

const TAX_SUMMARY_HEADER = [
  { header: 'GST%', accessor: 'gst' },
  { header: 'Taxable Amount', accessor: 'taxable' },
  { header: 'CGST Amt', accessor: 'cgst' },
  { header: 'SGST Amt', accessor: 'sgst' },
  { header: 'IGST Amt', accessor: 'igst' }
];

const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: 'createdAt' },
  { header: 'Patient Name', accessor: (row) => `${row?.name_suffix} ${row?.first_name} ${row?.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
  {
    header: 'CNT No',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.cnt}`}
        </span>
      );
    }
  },
  {
    header: 'CNT Type',
    accessor: 'type'
  },
  {
    header: 'CNT Date',
    accessor: (row) => `${formatDate('date', row.cnt_date)}`
  },
  {
    header: 'Product Type',
    accessor: 'type'
  },
  {
    header: 'Location',
    accessor: (row) => row?.location?.warehouse_name
  },
  {
    header: 'Supplier Name',
    accessor: (row) => row?.supplier?.ledger_name
  },
  {
    header: 'Invoice No',
    accessor: 'invoice_no'
  },
  {
    header: 'Net Amount',
    accessor: 'net_amt'
  },
  {
    header: 'Created At',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const initialConsignmentDataObj = {
  data: [],
  loading: false
};

export const ConsignmentReceipt = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [consignmentDataObj, setConsignmentDataObj] = useState(initialConsignmentDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [patientDataList, setPatientDataList] = useState([]);
  const [warehouse, setWareHosue] = useState([]);
  const [addtcdDialogue, setAddtcdDialogue] = useState(false);
  const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false);
  const [accountLedger, setAccountLedger] = useState([]);
  const [productDropdown, setProductDropdown] = useState([]);
  const [filteredServiceList, setFilteredServiceList] = useState([]);
  const [users, setUsers] = useState([]);
  const [isUserListLoaded, setIsUserListLoaded] = useState(false);
  const [wareHouseDropdown, setWareHouseDropdown] = useState([]);
  const [againstPoDialog, setAgainstPoDialog] = useState(false);
  const [poDetailList, setPoDetailList] = useState([]);


  const [detailListEditData,setDetailListEditData] = useState([])
  const [detailListEditMode,setDetailListEditMode] = useState(false)

  const user = JSON.parse(localStorage.getItem('user'));
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        invoice_from: Yup.string().required(' '),
        invoice_no:Yup.string().required(' '),
      })
    ),
    defaultValues: {
      type:"Direct",
      product_type: 'Pharmacy Product',
      cnt_date: new Date().toISOString().split('T')[0],
      invoice_date: new Date().toISOString().split('T')[0],
      bill: {
        out_sourced: 'No',
        // rec_amt_1: 0,
        // rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;
  const column = watch('view_column');
  const BILL_TABLE_HEADER = [
    { header: 'PO No.', accessor: 'po_no' },
    { header: 'Product Name', accessor: (row) => row?.product_name || row?.product?.main?.name },
    column ? { header: 'HSN Code', accessor: 'hsn_code' } : null,
    column ? { header: 'Packing', accessor: 'packing' } : null,
    { header: 'Unit', accessor: 'unit' },
    { header: 'PO Qty', accessor: 'po_qty' },
    { header: 'Bill Qty', accessor: 'bill_qty' },
    { header: 'Free Qty', accessor: 'free_qty' },
    { header: 'Rate', accessor: 'rate' },
    { header: 'Amount', accessor: 'amount' },
    { header: 'Disc Amt', accessor: 'dis_amt' },
    { header: 'Taxable', accessor: 'taxable' },
    { header: 'Gst%', accessor: 'gst' },
    column ? { header: 'CGST Amt', accessor: 'cgst' } : null,
    column ? { header: 'SGST Amt', accessor: 'sgst' } : null,
    column ? { header: 'IGST Amt', accessor: 'igst_amt' } : null,
    { header: 'Net Amt', accessor: 'net_amt' },
    { header: 'MRP', accessor: 'mrp' },
    { header: 'Batch No.', accessor: 'batch_no' },
    {
      header: 'Exp Date',
      accessor: (row) => `${getMonthYear(row.exp_date)}`
    }
  ].filter(Boolean);


   const PO_DETAIL_TABLE_HEADER = [
    {
      header: 'PO No.',
      accessor: 'po_no'
    },
    {
      header: 'Product Name',
      accessor: (row) => row?.product_name 
    },
    { header: 'HSN Code', accessor: 'hsn_code' },
    { header: 'Packing', accessor: 'packing' },
    { header: 'UnitId', accessor: 'unit_id' },
    { header: 'Unit', accessor: 'unit' },
    { header: 'PO Qty', accessor: 'order_qty' },
    { header: 'Bill Qty', accessor: 'bill_qty' },
    { header: 'Free Qty', accessor: 'free_qty' },
    { header: 'Rate', accessor: 'rate' },
    { header: 'Amount', accessor: 'amount' },
    { header: 'Disc Amt', accessor: 'dis_amt' },
    { header: 'Taxable', accessor: 'taxable' },
    { header: 'Gst%', accessor: 'gst' },
    { header: 'CGST Amt', accessor: 'cgst' },
    { header: 'SGST Amt', accessor: 'sgst' },
    { header: 'IGST Amt', accessor: 'igst_amt' },
    { header: 'Net Amt', accessor: 'net_amt' },
    { header: 'MRP', accessor: 'mrp' },
    { header: 'Batch No.', accessor: 'batch_no' },
    {
      header: 'Exp Date',
      accessor: (row) => `${getMonthYear(row.exp_date)}`
    }
  ];

  console.log(detailList, 'DETAIL LIST');
  const watchTotalAmt = watch('total_amt');
  const watchTotalDiscPer = watch('total_disc_per');
  const watchTotalDiscAmt = watch('total_disc_amt');
  const watchNetAmt = watch('net_amt');

const totalGstAmt = detailList.reduce((sum, item) => sum + item.gst_amt, 0);
useEffect(() => {
  if (watchTotalAmt && watchTotalDiscPer != null) {
    const grossAmt = watchTotalAmt + totalGstAmt;
    const calculatedDiscAmt = (grossAmt * watchTotalDiscPer) / 100;
    setValue('total_disc_amt', (calculatedDiscAmt));
    const calculatedNetAmt = grossAmt - calculatedDiscAmt;
    setValue('net_amt', calculatedNetAmt.toFixed(2));
  }
}, [watchTotalAmt, watchTotalDiscPer, totalGstAmt]);

useEffect(() => {
  if (watchTotalAmt && watchTotalDiscAmt != null) {
    const grossAmt = watchTotalAmt + totalGstAmt;
    const calculatedDiscPer = (watchTotalDiscAmt / grossAmt) * 100;
    setValue('total_disc_per', calculatedDiscPer);
    const calculatedNetAmt = grossAmt - watchTotalDiscAmt;
    setValue('net_amt', calculatedNetAmt.toFixed(2));
  }
}, [watchTotalAmt, watchTotalDiscAmt, totalGstAmt]);

  useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;

    detailList.forEach((detail) => {
      total_qty += detail.rec_qty;
      total_amt += detail.amount;
      disc_amt += detail.disc_amt;
      gst_amt += detail.gst_amt;
      net_amt += detail.net_amt;
    });

    // Round net_amt to the nearest integer
    const roundedNetAmt = Math.round(net_amt);

    // Calculate the round off difference (original net_amt - rounded net_amt)
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));

    // Set the calculated values
    setValue('total_qty', total_qty);
    setValue('total_amt', total_amt);
    setValue('disc_amt', disc_amt);
    setValue('gst_amt', gst_amt);
    setValue('net_amt', roundedNetAmt); // Set the rounded value as net_amt
    setValue('round_off', Math.abs(roundOff)); // Set the absolute value of the round off difference
  }, [detailList, setValue]);


     useEffect(() => {
    let total_qty = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;

    poDetailList?.forEach(
      (detail) => {
        total_qty += detail.rec_qty;
        total_amt += detail.amount;
        disc_amt += detail.disc_amt;
        gst_amt += detail.gst_amt;
        net_amt += detail.net_amt;
      },
      [poDetailList]
    );

    const roundedNetAmt = Math.round(net_amt);
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));
    setValue('total_qty', total_qty);
    setValue('total_amt', total_amt);
    setValue('disc_amt', disc_amt);
    setValue('gst_amt', gst_amt);
    setValue('net_amt', roundedNetAmt);
    setValue('round_off', Math.abs(roundOff));
  }, [poDetailList, setValue]);


  const netAmtWatch = watch('bill.net_amt');
  const recAmt1Watch = watch('bill.rec_amt_1');
  const recAmt2Watch = watch('bill.rec_amt_2');
  const payMode = watch('bill.pay_mode');

  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;
    if (payMode === 'CASH') {
      setValue('bill.rec_amt_1', netAmtWatch);
      setValue('bill.rec_amt_2', 0);
      setValue('bill.balance_amt', 0);
      setValue('bill.total_recpt', netAmtWatch);
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('bill.rec_amt_1', 0);
      setValue('bill.rec_amt_2', netAmtWatch);
      setValue('bill.balance_amt', 0);
      setValue('bill.total_recpt', netAmtWatch);
    } else {
      setValue('bill.total_recpt', total_recpt);
      setValue('bill.balance_amt', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'add_details',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
        if (selectedRecord.type === 'Direct') {
          const updatedDetails = selectedRecord.add_details.map((item) => ({
          ...item,
         gst_amt: (item.amount * item.gst) / 100,
         product:item.product._id,
         product_name:item?.product?.main?.name,
         originalData: {
          taxable: item.taxable,
          net_amt: item.net_amt
        }
        }));
      setDetailList(updatedDetails);
      } else if(selectedRecord.type === 'Against PO'){
        const updatedDetails = selectedRecord.add_details.map((item) => ({
          ...item,
         gst_amt: (item.amount * item.gst)/100,
         originalData: {
          taxable: item.taxable,
          net_amt: item.net_amt
        }
        }));
        setPoDetailList(updatedDetails);
      }
      setValue('invoice_no', selectedRecord?.invoice_no);
      setValue('cnt', selectedRecord?.cnt);
      const formattedCrnDate = selectedRecord?.cnt_date
        ? new Date(selectedRecord.cnt_date).toISOString().split('T')[0]
        : '';
      setValue('cnt_date', formattedCrnDate);
      const formattedInvoiceDate = selectedRecord?.invoice_date
        ? new Date(selectedRecord.invoice_date).toISOString().split('T')[0]
        : '';
      setValue('invoice_date', formattedInvoiceDate);
      setValue('type', selectedRecord?.type);
      setValue('supplier', selectedRecord?.supplier?._id);
      setValue('location', selectedRecord?.location?._id);
      setValue('product_type', selectedRecord?.product_type);
      setValue('invoice_from', selectedRecord?.invoice_from);
      setValue('amd_no', selectedRecord?.amd_no);
      setValue('remarks', selectedRecord?.remarks);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
      setValue('gst_inclusive', selectedRecord?.gst_inclusive);
      setValue('total_disc_per', selectedRecord?.total_disc_per);
      setValue('total_disc_amt', selectedRecord?.total_disc_amt);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(
    () => {
      getAccountLedgerData();
    },
    { getAccountLedgerData }
  );

  const getProductDropdown = useCallback(async () => {
    const data = await axios.get(`${BASE_URL}/product-master/dropdown?limit=${50}`);
    if (data?.data.data) {
      setProductDropdown(data.data.data);
      setFilteredServiceList(data.data.data);
    }
  }, []);

  useEffect(() => {
    getProductDropdown();
  }, [getProductDropdown]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the Details first', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const payload = { ...formValues, 
    add_details: detailList.length > 0 ? detailList : poDetailList.length > 0 ? poDetailList : [],
         taxDetails:groupedData?.length > 0
                      ? groupedData
                        : groupedpoData?.length > 0
                          ? groupedpoData
                          : []
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/consignment-receipt-update' : '/consignment-receipt-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user?.name,
        updatedBy: editFlag ? user?.name : '',
        organisation
      }
    });
    console.log(response, 'HELLO RESPONSE');
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'Edited' : 'created'} Consignment Receipt`, { variant: 'success' });
      setCurrentAction();
      setPoDetailList([])
      setDetailList([])
      // setSelectedRecord(response?.data);
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Consignment Receipt`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) =>
      prev.filter((data) => {
        return data._id !== rowId;
      })
    );
  };

  const watchGstinclusive = watch('gst_inclusive');
  const onDetailAddHandler = (data) => {
   setDetailList((prev) => {
    const existingIndex = prev.findIndex((item) => item._id === data._id);
    if (existingIndex !== -1) {
      if (detailListEditMode) {
        const updatedList = [...prev];
        const updatedEntry = {
          ...data,
          type: 'Purchase',
          originalData: {
            taxable: data?.taxable,
            net_amt: data?.net_amt,
          },
        };
        updatedList[existingIndex] = updatedEntry;
        return updatedList;
      } else {
        return prev;
      }
    } else {
      const productName = !detailListEditMode 
        ? productDropdown.find(({ _id }) => _id === data.product)?.main?.name 
        : undefined;

      const newEntry = {
        ...data,
        type: 'Purchase',
        product_name: productName,
        originalData: {
          taxable: data?.taxable,
          net_amt: data?.net_amt,
        },
      };
      return [...prev, newEntry];
    }
  });
  if (detailListEditMode) {
    toast("Detail List Updated Successfully", { variant: 'success' });
    setAddDetailsDialogOpen(false);
  } else {
    toast("Detail List Added Successfully", { variant: "success" });
  }
  };


     const onDetailPohandler = (data) => {
    const existingDetail =  poDetailList?.find(({ product }) => product === data.product);
    if (existingDetail) {
      toast('Product already chosen', { variant: 'error' });
      return;
    } else {
      toast('Product Added Successfully', { variant: 'success' });
    }
    setPoDetailList((prev) => [
      ...prev,
      {
        ...data,
        type: 'Purchase',
        originalData: {
          taxable: data?.taxable,
          net_amt: data?.net_amt
        }
      }
    ]);
  };

  const updateDetailListBasedOnGstinclusive = (gstInclusive) => {
    setDetailList((prevDetailList) => {
      return prevDetailList.map((item) => {
        if (!gstInclusive) {
          return {
            ...item,
            taxable: item?.originalData?.taxable,
            net_amt: item?.originalData?.net_amt
          };
        }
        let updatedTaxable = parseFloat(item?.taxable || 0);
        let updatedGstAmount = parseFloat(item?.gst_amt || 0);
        let updatedAmount = parseFloat(item?.amount || 0);
        let updatedNetAmount = parseFloat(item?.net_amt || 0);

        updatedTaxable = updatedTaxable - updatedGstAmount;
        updatedNetAmount = updatedTaxable + updatedGstAmount;
        return {
          ...item,
          taxable: updatedTaxable,
          net_amt: updatedNetAmount
        };
      });
    });
  };

      const updatePoDetailListBasedOnGstinclusive = (gstInclusive) => {
    setPoDetailList((prevDetailList) => {
      return prevDetailList.map((item) => {
        if (!gstInclusive) {
          return {
            ...item,
            taxable: item?.originalData?.taxable,
            net_amt: item?.originalData?.net_amt
          };
        }
        let updatedTaxable = parseFloat(item?.taxable || 0);
        let updatedGstAmount = parseFloat(item?.gst_amt || 0);
        let updatedAmount = parseFloat(item?.amount || 0);
        let updatedNetAmount = parseFloat(item?.net_amt || 0);

        updatedTaxable = updatedTaxable - updatedGstAmount;
        updatedNetAmount = updatedTaxable + updatedGstAmount;
        return {
          ...item,
          taxable: updatedTaxable,
          net_amt: updatedNetAmount
        };
      });
    });
  };

  useEffect(() => {
    if (detailList && detailList.length > 0) {
      updateDetailListBasedOnGstinclusive(watchGstinclusive);
    }
  }, [watchGstinclusive]);


    useEffect(() => {
    if (poDetailList && poDetailList.length > 0) {
      updatePoDetailListBasedOnGstinclusive(watchGstinclusive);
    }
  }, [watchGstinclusive]);


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/consignment-receipt-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancel Consignment Receipt', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancel Consignment Receipt', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/consignment-receipt-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Consignment Receipt', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Consignment Receipt', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setConsignmentDataObj({ loading: true });
    const response = await request('/consignment-receipt-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setConsignmentDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setConsignmentDataObj({ loading: false });
    }
  };

  useEffect(() => {
    if (consignmentDataObj.data && consignmentDataObj.data.length > 0) {
      setOriginalData(consignmentDataObj.data);
      setIsFiltered(false);
    }
  }, [consignmentDataObj.data]);

  useEffect(() => {
    handleConsignmentSearch(input);
  }, [input]);

  const handleConsignmentSearch = async () => {
    const lowercasedInput = input.toUpperCase().trim();
    const limit = 10;
    try {
      const response = await request('/consignment-receipt-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setConsignmentDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setConsignmentDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setConsignmentDataObj({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const getWarehouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  useEffect(() => {
    getWarehouseDropdown();
  }, [getWarehouseDropdown]);
  const summary = watch('show_summary');

  const groupDataByGST = (data) => {
    const groupedData = {};

    // Group data by GST%
    data.forEach((item) => {
      if (!groupedData[item.gst]) {
        groupedData[item.gst] = {
          gst: item.gst,
          taxable: 0,
          cgst: 0,
          sgst: 0,
          igst: 0,
          count: 0
        };
      }

      // Aggregate values for each group
      groupedData[item?.gst].taxable += item?.taxable;
      groupedData[item?.gst].cgst += item?.cgst;
      groupedData[item?.gst].sgst += item?.sgst;
      groupedData[item?.gst].igst += item?.igst;
      groupedData[item?.gst].count += 1;
    });

    // Convert groupedData object to array for rendering in table
    return Object.values(groupedData);
  };
  const groupedData = groupDataByGST(detailList || []);


      const groupDataByGSTPurchaseOrder = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      if (!groupedData[item.gst]) {
        groupedData[item.gst] = {
          gst: item.gst,
          taxable: 0,
          cgst: 0,
          sgst: 0,
          igst: 0,
          count: 0
        };
      }
      groupedData[item.gst].taxable += item.taxable;
      groupedData[item.gst].cgst += item.cgst;
      groupedData[item.gst].sgst += item.sgst;
      groupedData[item.gst].igst += item.igst;
      groupedData[item.gst].count += 1;
    });
    return Object.values(groupedData);
  };
  const groupedpoData = groupDataByGSTPurchaseOrder(poDetailList || []);

  const getUserList = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      const filteredUsers = response.data.filter((data) => {
        const [firstName, lastName] = user?.name.split(' ');
        return data?.first_name === firstName && data?.last_name === lastName;
      });
      setUsers(filteredUsers[0]?._id);
      setIsUserListLoaded(true);
    } catch (error) {
      console.error('Error fetching user list:', error);
      setIsUserListLoaded(true);
    }
  };

  const handleWareHouseDropdown = async () => {
    if (!isUserListLoaded) return;
    setWareHouseDropdown({ loading: true, data: [] });
    try {
      const query = { name: users };
      console.log(query, 'QUERY');
      const response = await request('/user-wise-warehouse-mapping-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        setWareHouseDropdown({ loading: false, data: response.data.flatMap((item) => item.selectedWarehouse) });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setWareHouseDropdown({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setWareHouseDropdown({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    if (isUserListLoaded) {
      handleWareHouseDropdown();
    }
  }, [isUserListLoaded]);

    const watchSupplier = watch('supplier');
  const handleDetailListEdit = (row) => {
    setAddDetailsDialogOpen(true);
    setDetailListEditData(row);
    setDetailListEditMode(true);
  
  };


function getSafeUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Consignment Receipt
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>CNT Date</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.3 }}
                    type="date"
                    name="cnt_date"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>CNT/Amd No.</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="cnt" placeholder="CNT" />
                  <TextField disabled sx={{ flex: 0.2 }} name="amd_no" />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="type"
                    placeholder="Type"
                    menus={PHARMACY_TYPE_MENUS_CONSIGNMENT}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Invoice No</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.3 }}
                    name="invoice_no"
                    placeholder="Invoice No"
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Invoice Date</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.5 }}
                    name="invoice_date"
                    type="date"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.28, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.3 }}
                    name="location"
                    placeholder="Location"
                    menus={wareHouseDropdown?.data?.map((warehouse) => ({
                      ...warehouse,
                      name: warehouse?.warehouse_name
                    }))}
                  />
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    placeholder="Select Product Type"
                    formControlSX={{ flex: 0.5 }}
                    name="product_type"
                    menus={PHARMACY_PRODUCT_TYPE_MENUS}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: '1.4rem' }}>Supplier</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.9 }}
                    name="supplier"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data?.ledger_name
                    }))}
                    placeholder="Select Supplier"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: '1.4rem' }}>Invoice From</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="invoice_from"
                    placeholder="Invoice From"
                    menus={accountLedger.map((data) => ({
                      ...data,
                      name: data?.ledger_name
                    }))}
                  />
                </Stack>
              </Stack>
            </Box>

            <Grid
              item
              xs={12}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, boxShadow: '0px 2px 2px #0099ff' }}
            >
              <Stack spacing={1} direction="row" justifyContent="space-between">
                <Button
                  variant="contained"
                  disabled={!['new', 'edit'].includes(currentAction) || !watch('supplier')}
                  onClick={() => {
                    setDetailListEditMode(false);
                    const productType = watch('type');
                    if (productType === 'Direct') {
                      setAddDetailsDialogOpen(true);
                    } else if (productType === 'Against PO') {
                      setAgainstPoDialog(true);
                    }
                  }}
                >
                  Add Details
                </Button>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="view_column"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>
                    View All Columns in Table
                  </Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="gst_inclusive"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Gst Inclusive</Typography>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                  <Checkbox
                    formControlSX={{ flex: 0.8 }}
                    name="show_summary"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    fontSize={18}
                  />
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Show Summary</Typography>
                </Stack>
              </Stack>
              {watch('type') === 'Direct' ? (
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                 data={detailList?.map((item) => {
                    if (!item._id) item._id = getSafeUUID();
                    return item;
                  })}
                  columns={BILL_TABLE_HEADER}
                  size="small"
                  showEditButton={["new","edit"].includes(currentAction) ? true : false}
                  onClickEditRow={handleDetailListEdit}
                  handleDeleteRow={handleRowDelete}
                />
              ) : watch('type') === 'Against PO' ? (
                <Table
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                  data={(poDetailList && poDetailList.map((data) => ({ _id: data.product, ...data }))) || []}
                  columns={PO_DETAIL_TABLE_HEADER}
                  size="small"
                  showDeleteAction={true && ['new', 'edit'].includes(currentAction)}
                  onDeleteHandler={handleRowDelete}
                />
              ) : null}
            </Grid>
            {summary === true && (
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={'20rem'}>
                <Table
                  containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                  data={groupedData?.length > 0 ? groupedData : groupedpoData?.length > 0 ? groupedpoData : []}
                  columns={TAX_SUMMARY_HEADER}
                  size="small"
                  onDeleteHandler={handleRowDelete}
                />

                <Stack sx={{ flex: 1 }} spacing={0.5} direction="column">
                  {/* Total Qty */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Qty</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="total_qty" />
                  </Stack>
                  {/* Total Amount */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Amount</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="total_amt" />
                  </Stack>
                  {/* Total TCD */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Total Discount</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.35 }}
                      name="total_disc_per"
                      placeholder="Disc%"
                      type="number"
                    />
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.35 }}
                      name="total_disc_amt"
                      placeholder="Disc Amt"
                      type="number"
                    />
                  </Stack>
                  {/* Round Off */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Round Off</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="round_off" />
                  </Stack>
                  {/* Net Amount */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Net Amount</Typography>
                    <TextField disabled sx={{ flex: 0.7 }} name="net_amt" />
                  </Stack>
                  {/* Remarks */}
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.7 }}
                      name="remarks"
                      placeholder="Enter Remarks"
                    />
                  </Stack>
                </Stack>
              </Stack>
            )}
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Consignment Receipt Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Consignment Receipt"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={consignmentDataObj?.data || []}
          loading={consignmentDataObj.loading}
          onRowClick={(row) => {
            if (row.in_stock_master) {
              toast('You Can Not Update This Good Receipt Note It is Authorised!', { variant: 'warning' });
              return;
            }
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      {/* <Dialog
                open={addtcdDialogue}
                onClose={() => setAddtcdDialogue(false)}
                PaperProps={{ sx: { width: '80%', height: '90vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddTCDForm
                    onClose={() => setAddtcdDialogue(false)}
                />
            </Dialog> */}

      <Dialog
        open={addDetailsDialogue}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '100vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddDetails
          onClose={() => setAddDetailsDialogOpen(false)}
          onAdd={onDetailAddHandler}
          productDropdown={productDropdown}
          setFilteredServiceList={setFilteredServiceList}
          filteredServiceList={filteredServiceList}
          setProductDropdown={setProductDropdown}
          detailListEditData={detailListEditData}
          detailListEditMode={detailListEditMode}
          setDetailListEditMode={setDetailListEditMode}
          setDetailListEditData={setDetailListEditData}
        />
      </Dialog>

      <Dialog
        open={againstPoDialog}
        onClose={() => setAgainstPoDialog(false)}
        PaperProps={{ sx: { width: '75%', height: '90vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AgainstPoAddDetailsForm
          onClose={() => setAgainstPoDialog(false)}
          onAdd={onDetailPohandler}
          productDropdown={productDropdown}
          filteredServiceList={filteredServiceList}
          setFilteredServiceList={setFilteredServiceList}
          setProductDropdown={setProductDropdown}
          supplier={watchSupplier}
        />
      </Dialog>
    </>
  );
};
